import { render, staticRenderFns } from "./do_submitted.vue?vue&type=template&id=722f634a&scoped=true&"
import script from "./do_submitted.vue?vue&type=script&lang=js&"
export * from "./do_submitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f634a",
  null
  
)

export default component.exports